import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import numeral from 'numeral';
import FilterWrapper from '../../FilterWrapper';
import PriceSliderPopover from './PriceSliderPopover';
import { setOpenSearchFilter } from '../../../../actions';
import { t } from '../../../../helpers/t';

const FILTER_NAME = 'price';

const registeredLocales = [];

const DailyPriceFilter = () => {
  const {
    openSearchFilter,
    parameters: {
      daily_price_lteq: price_lteq,
      daily_price_gteq: price_gteq,
    },
  } = useSelector((state) => state.searchFilters);
  const { locales } = useSelector((state) => state.env);

  const {
    locale: {
      search: {
        price_max: maxPrice,
      },
      currency,
      locale,
    },
  } = useSelector((state) => state.searchResults);

  const dispatch = useDispatch();

  const toggleFilterVisible = () => (
    openSearchFilter === FILTER_NAME
      ? dispatch(setOpenSearchFilter(null))
      : dispatch(setOpenSearchFilter(FILTER_NAME))
  );

  useEffect(() => {
    // load all locales in numeral module
    locales.forEach((l) => {
      if (registeredLocales.indexOf(l.locale) === -1) {
        registeredLocales.push(l.locale);
        numeral.register('locale', l.locale, {
          delimiters: {
            thousands: l.currency.delimiter,
            decimal: l.currency.separator,
          },
          currency: {
            symbol: l.currency.unit,
          },
        });
      }
    });
  }, []);

  useEffect(() => {
    numeral.locale(locale || 'en_US');
  }, [locale]);

  function setPriceDescription(price_lteq, price_gteq, maxPrice, currency) {
    if (!(price_lteq || price_gteq) || (price_gteq === 0 && price_lteq === maxPrice)) {
      return t('directives.listings.listingFilters.dailyPrice');
    }

    if (price_lteq && price_gteq && price_lteq !== maxPrice && price_gteq !== 0) {
      const gteq = currency
        .format
        .replace('%u', currency.unit)
        .replace('%n', numeral(price_gteq / 100).format());

      const lteq = currency
        .format
        .replace('%u', currency.unit)
        .replace('%n', numeral(price_lteq / 100).format());

      return `${gteq} - ${lteq}`;
    }

    if (price_lteq <= (maxPrice - 1) && currency) {
      const display = currency
        .format
        .replace('%u', currency.unit)
        .replace('%n', numeral(price_lteq / 100).format());

      return t('directives.listings.listingFilters.formatting.dailyPrice.under', { lte: display });
    }

    if (price_gteq !== 0 && currency) {
      const display = currency
        .format
        .replace('%u', currency.unit)
        .replace('%n', numeral(price_gteq / 100).format());

      return t('directives.listings.listingFilters.formatting.dailyPrice.over', { gte: display });
    }

    return `${price_lteq} +`;
  }

  let priceDescription = setPriceDescription(price_lteq, price_gteq, maxPrice, currency);
  useEffect(() => {
    priceDescription = setPriceDescription(price_lteq, price_gteq, maxPrice, currency);
  }, [price_lteq, price_gteq, maxPrice, currency, t]);

  return (
    <FilterWrapper>
      <PriceSliderPopover>
        <Button type={(price_lteq || price_gteq) ? 'primary' : 'default'} onClick={() => toggleFilterVisible()}>
          {priceDescription}
        </Button>
      </PriceSliderPopover>
    </FilterWrapper>
  );
};

export default DailyPriceFilter;
